























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import CharacterIcon from '@/components/parts/CharacterIcon.vue';
import * as api from '@/api/api';
import * as def from '@/common/definitions';
import ArrayUtil from '@/models/common/arrayutil';
import Enumerable from 'linq';

@Component({
  components: {
    CharacterIcon,
  },
})
export default class GenerateItemTypePicker extends Vue {
  public itemTypes: def.CharacterItemType[] = [];
  @Prop({
    default: () => new def.CharacterItemType(-1),
  }) public value!: def.CharacterItemType;
  @Prop({
    default: () => [],
  }) public skills!: api.CharacterSkill[];

  @Watch('skills')
  public onSkillsChanged() {
    this.itemTypes = [];
    if (this.skills.some((s) => s.type === 17)) {
      this.addItemType(78);
      this.addItemType(79);
      this.addItemType(80);
    }
    if (this.skills.some((s) => s.type === 20)) {
      this.addItemType(64);
      this.addItemType(77);
      this.addItemType(63);
    }
    if (this.skills.some((s) => s.type === 29)) {
      this.addItemType(67);
      this.addItemType(68);
    }
    if (this.skills.some((s) => s.type === 32)) {
      this.addItemType(69);
    }
    if (this.skills.some((s) => s.type === 35)) {
      this.addItemType(70);
    }
    if (this.skills.some((s) => s.type === 38)) {
      this.addItemType(85);
    }
    if (this.skills.some((s) => s.type === 39)) {
      this.addItemType(71);
    }
    if (this.skills.some((s) => s.type === 43)) {
      this.addItemType(73);
    }
    if (this.skills.some((s) => s.type === 44)) {
      this.addItemType(72);
    }
  }

  private addItemType(id: number) {
    const item = def.CHARACTER_ITEM_TYPES.find((val) => val.id === id);
    if (item) {
      this.itemTypes.push(item);
    }
  }

  private getItemMoney(item: def.CharacterItemType): number {
    const m = !item.isResource ? item.money : item.money * item.defaultResource;

    return m;
  }
}
